import { ContentTypes, Footer } from "@veneer/core";
import { useState } from "react";

export default function FooterComponent() {

  const content:ContentTypes = {leadingArea: []}

  const [mainContent, SetMainContent] = useState(content);

  return (
    <div>
      <Footer appearance="ultraminimal"  mainContent={mainContent} />
    </div>
  );
}